import React from 'react';
import { Link } from 'react-router-dom';
import { FaCrown, FaTrophy, FaHome } from 'react-icons/fa';
import SectionCard from '../SectionCard';
import './Winner.css';

const CONFETTI_COLORS = ['#0dff00', '#1dff85', '#ffd54a', '#37a2ff', '#ff5c7f'];

const confettiPieces = Array.from({ length: 16 }, (_, index) => ({
  id: index,
  left: `${(index * 37) % 100}%`,
  delay: `${(index % 8) * 0.3}s`,
  duration: `${3 + (index % 4) * 0.6}s`,
  color: CONFETTI_COLORS[index % CONFETTI_COLORS.length],
}));

const Winner = ({ winner }) => {
  if (!winner) {
    return null;
  }

  return (
    <SectionCard title="Campeón" icon={<FaTrophy />} description="La gloria del torneo ya tiene dueño." className="winner-card">
      <div className="winner">
        <div className="winner__confetti" aria-hidden="true">
          {confettiPieces.map((piece) => (
            <span
              key={piece.id}
              className="winner__confetti-piece"
              style={{
                left: piece.left,
                animationDelay: piece.delay,
                animationDuration: piece.duration,
                backgroundColor: piece.color,
              }}
            />
          ))}
        </div>

        <div className="winner__trophy">
          <FaTrophy />
        </div>

        <h1><FaCrown /> ¡Campeón del torneo!</h1>
        <p className="winner__name">{winner.name}</p>

        <Link to="/" className="btn btn--ghost winner__back">
          <FaHome /> Volver al inicio
        </Link>
      </div>
    </SectionCard>
  );
};

export default Winner;
